//  Extracted functions to remove code duplication


/**
 * Formats the input data into a formatted string.
 * Requires an input of a number or array of numbers.
 *
 * @param {number|number[]} inputValue - The input value or array of input values.
 * @param {boolean} [useDollarSign=true] - Indicates whether to use the dollar sign in the output.
 * @returns {string} The formatted input data.
 */
export const formatInputData = (inputValue, useDollarSign = true) => {
    let inputData;

    //  Resolve to an arrray of numbers or numbers with nulls matching isNan values.
    if (!Array.isArray(inputValue)) {
        inputData = !isNaN(inputValue) ? [inputValue] : [0];
    } else {
        inputData = inputValue.length === 0 ? [0] : inputValue.map(v => (!isNaN(v) ? v : null));
    }

    //  If we found a null, just transform it to a single element array of 0,
    //  otherwise take the first 2, sorted.
    if (inputData.find(f => f === null) !== undefined) {
        inputData = [0]
    } else {
        inputData = inputData.slice(0, 2).sort((a, b) => a - b);
    }

    //  Split into groups of 3, comma separated, with a possible dollar sign
    return inputData.map(t => (useDollarSign ? '$' : '') +
        t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")).join(" - ");
};